import { render, staticRenderFns } from "./OfferMaintain.vue?vue&type=template&id=53f505ca"
import script from "./OfferMaintain.vue?vue&type=script&lang=js"
export * from "./OfferMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f505ca')) {
      api.createRecord('53f505ca', component.options)
    } else {
      api.reload('53f505ca', component.options)
    }
    module.hot.accept("./OfferMaintain.vue?vue&type=template&id=53f505ca", function () {
      api.rerender('53f505ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/OfferMaintain.vue"
export default component.exports